<template>
	<footer id="footer" role="contentinfo" class="clearfix">
		<div class="container-xl">
			<a href="https://www.protezionecivile.fvg.it/" class="footer_title">PROTEZIONE CIVILE DELLA REGIONE</a>
			<p><em>Indirizzo</em> Via Natisone 43 - 33057 PALMANOVA (UD)</p>
			<p>
				<em>Telefono</em> <a href="tel:0432926111">0432 926111</a> (centralino)
			</p>
			<p><em>Fax</em> 0432 926000</p>
			<p>
				<em>E-mail</em>
				<a href="mailto:segreteria@protezionecivile.fvg.it"
					>segreteria@protezionecivile.fvg.it</a
				>
			</p>
			<p>
				<em>Indirizzo di posta certificata</em>
				<a href="mailto:protezione.civile@certregione.fvg.it"
					>protezione.civile@certregione.fvg.it</a
				>
			</p>
			<p class="footer-info-dark">
				© Copyright 2020-2023 - Regione Autonoma Friuli Venezia Giulia. Protezione
				Civile della Regione / via Natisone 43, Palmanova (UD)
			</p>
			<p>
				<a href="https://www.protezionecivile.fvg.it/note-legali"
					>Condizioni di utilizzo e note legali</a
				>
				/
				<a
					href="https://www.protezionecivile.fvg.it/it/informativa-sulla-privacy"
					title="Privacy Policy"
					>Privacy Policy</a
				>
				/
			</p>
		</div>
	</footer>
</template>

<style>
footer {
  background-color: #f1f1f2;
  border-top: 1px solid #afafaf;
  margin-top: 50px;
  padding: 10px 0;
  font-size: 12px;
  color: gray;
}
footer a.footer_title {
	color: #0067b1;
	font-weight: bold;
	margin: 0;
	padding: 5px 0;
	font-size: 1.2em;
	text-decoration: none;
}
footer p {
	padding: 1px 0;
	margin: 0;
}
footer a {
	color: gray;
}
footer .footer-info-dark {
	color: #333;
}
</style>
